import React, { FC, useCallback, useState } from 'react';
import styles from './index.module.scss';
import { Button } from 'src/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-light-svg-icons';
import classNames from 'classnames';
import { FormInstance } from 'antd';
import { Content } from 'src/models/bids/ContentLibrary';
import { useTranslation } from 'react-i18next';
import { trackBTShowMoreOnGeneratedAnswer, trackBTUseGeneratedAnswer } from 'src/segment/events';
import { useTask } from 'src/models/bids/BidTask/hooks';

export const ContentLibraryBox: FC<{
  content: Content | null;
  form: FormInstance;
  setIsFocused: (isFocused: boolean) => void;
}> = ({ content, form, setIsFocused }) => {
  const { t } = useTranslation();
  const { data: task } = useTask();
  const [showMore, setShowMore] = useState(false);

  const onShowMore = useCallback(() => {
    if (!showMore && task) {
      trackBTShowMoreOnGeneratedAnswer(task.id, task.groupId, task.bidId, task.type);
    }

    setShowMore(prev => !prev);
  }, [showMore, task]);

  const onUseAnswer = useCallback(() => {
    if (task) {
      trackBTUseGeneratedAnswer(task.id, task.groupId, task.bidId, task.type);
    }

    form.setFieldsValue({ freeText: content?.answer });
    setIsFocused(true);
  }, [task, form, content?.answer, setIsFocused]);

  if (!content) return null;

  return (
    <div className={classNames(styles.box, { [styles.collapsed]: !showMore })}>
      <div>
        <h3 className={classNames(styles.question, { [styles.collapsed]: !showMore })}>{content.question}</h3>
        <p className={classNames(styles.answer, { [styles.collapsed]: !showMore })}>{content.answer}</p>
      </div>
      <div className={styles.actionBar}>
        <Button type="link" onClick={onShowMore}>
          {showMore ? t('Common.showLess') : t('Common.showMore')}
        </Button>
        <Button type="link" onClick={onUseAnswer} icon={<FontAwesomeIcon icon={faCopy} />}>
          Use answer
        </Button>
      </div>
    </div>
  );
};

export default ContentLibraryBox;
